<template>
    <div id="app">
        <localization style="min-height: 100vh"></localization>
        <div style="height: calc(100vh * 0.1479)"></div>
        <custom-footer></custom-footer>
        <cookie-law buttonText="รับทราบ" v-on:accept="accept()" v-if="authorized">
            <div slot="message">
                เราใช้คุกกี้เพื่อเพิ่มประสิทธิ์ภาพและประสบการณ์ที่ดีในการเข้าใช้เว็บไซต์ ท่านสามารถศึกษารายละเอียดการใช้คุกกี้ได้ที่ <span style="color: #0563c1; cursor: pointer" class="fw-600" @click="cookiePolicy"><u>นโยบายการใช้คุกกี้</u></span>
            </div>
        </cookie-law>
        <vue-confirm-dialog class="vue-confirm-dialog"></vue-confirm-dialog>
    </div>
</template>
<script>
// import store from 'store';
import { mapState } from 'vuex';
import Localization from '@/localization';
import CookieLaw from 'vue-cookie-law';
export default {
    name: 'app',
    components: { Localization, CookieLaw },
    computed: {
        ...mapState(['settings']),
        ...mapState('user', ['authorized']),
        nextRoute() {
            return this.$route.query.redirect || '/';
        },
        currentRoute() {
            return this.$route.path;
        },
    },
    mounted() {
        this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT');
        this.$store.commit('SET_PRIMARY_COLOR', {
            color: this.settings.primaryColor,
        });
        this.$store.commit('SET_THEME', { theme: this.settings.theme });
        if (this.authorized) {
            window['ga-disable-UA-189990896-1'] = false;
        } else {
            window['ga-disable-UA-189990896-1'] = true;
        }
    },
    methods: {
        accept() {},
        cookiePolicy() {
            // store.set('cookie:accepted', true);
            var r = this.$router.resolve({
                path: '/terms',
                query: { cookie_policy: 1, show_cookie: 1 },
            });
            window.location.assign(r.href);
        },
    },
    watch: {
        '$store.state.settings.theme'(theme) {
            this.$store.commit('SET_THEME', { theme });
        },
        authorized(authorized) {
            if (authorized && this.currentRoute === '/auth/login') {
                this.$router.replace(this.nextRoute);
            }
        },
        $route(to, from) {
            if (this.authorized) {
                window['ga-disable-UA-189990896-1'] = false;
            } else {
                window['ga-disable-UA-189990896-1'] = true;
            }
            const query = Object.assign({}, to.query);
            // if (to && to.path && to.path == '/auth/login') {
            //   console.log('to -->', to);
            //   console.log('from -->', from);
            // } else {
            this.$store.commit('SETUP_URL_SETTINGS', query);
            // }
        },
    },
};
</script>
<style>
.Cookie--base .Cookie__button {
    background: #5b9bd5;
}
.Cookie--base .Cookie__button:hover {
    background: #528bbf;
}
</style>
